import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: left;
  width: 100%;
  height: 100%;
  text-decoration: none;
  color: inherit;
  box-sizing: border-box;
  padding: 0;
  min-height: calc(2.5em + 5px);
  min-width: 0;
  overflow: hidden;

  &:hover {
    color: inherit;
  }
`;

const Content = styled.span`
  display: block;
  flex: 1 1 auto;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const LinkableCell = React.forwardRef(({ children, ...props }, ref) => (
  <StyledLink {...props} ref={ref}>
    <Content>{children}</Content>
  </StyledLink>
));

LinkableCell.displayName = "LinkableCell";

export default LinkableCell;
